export default () => [
  {
    path: '',
    meta: { isLiveChatHidden: false, isSeoBlockHidden: true, inBetting: true },
    component: () => import('layouts/BettingLayout.vue'),
    children: [
      {
        name: 'new-sport',
        meta: { isBasketHidden: true },
        path: '',
        component: () => import('src/pages/betting/Home.vue'),
      },
      {
        name: 'bet-promotions',
        meta: { isRightContainerHidden: true },
        path: 'promotions',
        component: () => import('src/pages/betting/promotions/Promotions.vue'),
      },
      {
        name: 'live-match',
        path: 'live-match/:sport_id/:id',
        component: () => import('pages/betting/live/LiveMatch.vue'),
      },
      {
        name: 'live-competition',
        path: 'live/:sport_id/:competition_id/',
        component: () => import('pages/betting/live/LiveCompetition.vue'),
      },
      {
        name: 'live-sport',
        path: 'live/:sport_id/',
        component: () => import('pages/betting/live/LiveSport.vue'),
      },
      {
        name: 'live',
        path: 'live',
        component: () => import('pages/betting/live/Live.vue'),
      },
      {
        name: 'line',
        path: 'line',
        component: () => import('pages/betting/line/Line.vue'),
      },
      {
        name: 'outrights',
        path: 'outrights',
        component: () => import('pages/betting/Outrights.vue'),
      },
      {
        name: 'schedule',
        path: 'schedule',
        component: () => import('pages/betting/Schedule.vue'),
      },
      {
        name: 'bet-history',
        meta: { auth: true, isRightContainerHidden: true },
        path: 'history',
        component: () => import('pages/betting/BettingHistory.vue'),
      },
      {
        name: 'bet-favorites',
        path: 'favorites',
        component: () => import('pages/betting/BettingFavorite.vue'),
      },
      {
        name: 'bet-basket',
        path: 'basket',
        meta: { isFooterHidden: true },
        component: () => import('pages/betting/BettingBasket.vue'),
      },
      {
        name: 'bet-fastbet',
        path: 'fastbet',
        component: () => import('pages/betting/BettingFastbet.vue'),
      },
      {
        name: 'bet-search',
        path: 'search',
        component: () => import('pages/betting/BettingSearch.vue'),
      },
      {
        name: 'bet-live-results',
        path: 'live-results',
        component: () => import('pages/betting/BettingLiveResults.vue'),
      },
      {
        path: 'results',
        component: () => import('pages/betting/results/Results.vue'),
        children: [
          {
            name: 'bet-results-sport',
            path: ':id',
            component: () => import('pages/betting/results/ResultsSport.vue'),
          },
          {
            name: 'bet-results-list',
            path: '',
            component: () => import('pages/betting/results/ResultsSports.vue'),
          },
        ],
      },
      {
        name: 'bet-statistics',
        path: 'statistics',
        component: () => import('pages/betting/BettingStatistics.vue'),
      },
      {
        name: 'bet-rules',
        meta: { isRightContainerHidden: true },
        path: 'rules',
        component: () => import('pages/betting/BettingRules.vue'),
      },

      // Линия live
      // {
      //   name: 'live-match',
      //   path: 'sport/:sport_id/:competition_id/:id',
      //   component: () => import('pages/betting/live/LiveMatch.vue'),
      // },
      // {
      //   name: 'live-competition',
      //   path: 'sport/:sport_id/:competition_id/',
      //   component: () => import('pages/betting/live/LiveCompetition.vue'),
      // },
      // {
      //   name: 'live-sport',
      //   path: 'sport/:sport_id/',
      //   component: () => import('pages/betting/live/LiveSport.vue'),
      // },
      //* Линия
      {
        name: 'line-champs',
        path: 'line/:sport_id/:time',
        component: () => import('src/pages/betting/line/LineChamps.vue'),
      },
      {
        name: 'line-matches',
        path: 'line/:sport_id/:competition_id/:time',
        component: () => import('src/pages/betting/line/LineMatches.vue'),
      },
      {
        name: 'line-stakes',
        path: 'line-stakes/:sport_id/:match_id/:time',
        component: () => import('src/pages/betting/line/LineStakes.vue'),
      },
      {
        name: 'calculator',
        path: 'calculator',
        meta: { isRightContainerHidden: true },
        component: () => import('src/pages/betting/Calculator.vue'),
      },
      {
        name: 'bet-spec',
        path: 'special-offers',
        meta: { isRightContainerHidden: true },
        component: () => import('pages/betting/BettingSpec.vue'),
      },
    ],
  },
]
